import React from 'react';
import Loading from '../components/atoms/Loading';

const withLoadingState = Component => props =>
  props.error ? <Loading {...props} /> : <Component {...props} />;

export default withLoadingState;
